var React = require('react');

function SocialFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M5.32 17V8.499h2.366L8 5.569H5.32l.004-1.466c0-.764.073-1.173 1.18-1.173h1.48V0H5.615C2.773 0 1.772 1.421 1.772 3.811V5.57H0V8.5h1.772V17H5.32z"}));
}

SocialFacebookInline.defaultProps = {"width":"8","height":"17","viewBox":"0 0 8 17"};

module.exports = SocialFacebookInline;

SocialFacebookInline.default = SocialFacebookInline;
